import { setupLayouts } from 'virtual:meta-layouts'
import generatedRoutes from 'virtual:generated-pages'
import type { RouteRecordRaw } from 'vue-router'
// import MultilevelMenuExample from './modules/multilevel.menu.example'
// import TabExample from './modules/tab.example'
import Option from './modules/option'
import TVRouter from './modules/tv'
import Position from './modules/position'
import TaskOption from './modules/task_option'
import Hedge from './modules/hedge'
import futuresTaskManage from './modules/futures_task_manager'
import getAccountOrder from './modules/getAccountOrder'
import lossUnable from './modules/loss_unable'
import movePosition from './modules/move_position'
import manualTrading from './modules/manual_trading'
import ManageUserAccount from './modules/manage_user_account'
import ManageGroup from './modules/manage_group'
import ManageExchangeAccount from './modules/manage_exchange_account'
import ManageStrategies from './modules/manae_strategies'
import type { Route } from '#/global'
import useSettingsStore from '@/store/modules/settings'

// 固定路由（默认路由）
const constantRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login.vue'),
    meta: {
      title: '登录',
    },
  },
  {
    path: '/:all(.*)*',
    name: 'notFound',
    component: () => import('@/views/[...all].vue'),
    meta: {
      title: '找不到页面',
    },
  },
]

// 系统路由
const systemRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/layouts/index.vue'),
    meta: {
      title: () => useSettingsStore().settings.home.title,
      breadcrumb: false,
    },
    children: [
      {
        path: '',
        component: () => import('@/views/index.vue'),
        meta: {
          title: () => useSettingsStore().settings.home.title,
          icon: 'i-ant-design:home-twotone',
          breadcrumb: false,
        },
      },
      {
        path: 'reload',
        name: 'reload',
        component: () => import('@/views/reload.vue'),
        meta: {
          title: '重新加载',
          breadcrumb: false,
        },
      },
    ],
  },
]

// 动态路由（异步路由、导航栏路由）
const asyncRoutes: Route.recordMainRaw[] = [
  {
    meta: {
      title: '策略',
      icon: 'i-uim:box',
    },
    children: [
      // Option,
      // TaskOption,
      // Position,
      futuresTaskManage,
      getAccountOrder,
      lossUnable,
      Hedge,
      movePosition,
      manualTrading,
    ],
  },
  {
    meta: {
      title: 'TV',
      icon: 'i-icon-park-outline:circular-connection',
    },
    children: [
      TVRouter,
    ],
  },
  {
    meta: {
      title: '权限管理',
      icon: 'i-mage:box-3d',
    },
    children: [
      ManageGroup,
      ManageUserAccount,
      ManageExchangeAccount,
      ManageStrategies,
    ],
  },
]

const constantRoutesByFilesystem = generatedRoutes.filter((item) => {
  return item.meta?.enabled !== false && item.meta?.constant === true
})

const asyncRoutesByFilesystem = setupLayouts(generatedRoutes.filter((item) => {
  return item.meta?.enabled !== false && item.meta?.constant !== true && item.meta?.layout !== false
}))

export {
  constantRoutes,
  systemRoutes,
  asyncRoutes,
  constantRoutesByFilesystem,
  asyncRoutesByFilesystem,
}
